export const pluralize = (num: number, singular: string, plural: string) =>
  num === 1 ? `${num} ${singular}` : `${num} ${plural}`

export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)
